import api from '../api/icaro';


// Listar todos os itens, com filtro opcional
export async function getItems(params) {
  const { data } = await api.get('/items', { params });
  return data;
}

// Buscar item por ID
export async function getItem(id) {
  const { data } = await api.get(`/items/${id}`);
  return data;
}

// Criar item
export async function storeItem(item) {
  const { data } = await api.post('/items', item);
  return data;
}

// Atualizar item
export async function updateItem(id, item) {
  const { data } = await api.put(`/items/${id}`, item);
  return data;
}

// Excluir item
export async function deleteItem(id) {
  await api.delete(`/items/${id}`);
}
